import { BusinessOutlined, BadgeOutlined, MonitorHeartOutlined, DescriptionOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { StatisticsBlock } from './StatisticsBlock';
import { StatisticsTab } from './StatisticsTab';

export const AdminHome = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <StatisticsBlock title="Быстрый доступ">
        <StatisticsTab icon={<BusinessOutlined />} label="Клиенты" onClick={() => navigate(ROUTES.clients.list)} />
        <StatisticsTab icon={<BadgeOutlined />} label="Водители" onClick={() => navigate(ROUTES.drivers.list)} />
        <StatisticsTab icon={<MonitorHeartOutlined />} label="Терминалы" onClick={() => navigate(ROUTES.terminals.list)} />
        <StatisticsTab icon={<DescriptionOutlined />} label="Путевые листы" onClick={() => navigate(ROUTES.waybills.list)} />
      </StatisticsBlock>
    </Box>
  );
};
